import { RoomEventDto, SpeakingSessionRoomDto } from 'api/planning';
import { Room } from './Room';
import styled from '@emotion/styled';
import { Icon } from '@britishcouncil/react-admin';
import { Timeline } from './Timeline';
import { ScrollClasses } from 'hooks';
import { useMemo } from 'react';
import { useRooms } from './useRooms';

type Props = {
  speakingSessionRooms: SpeakingSessionRoomDto[];
  roomsEvents: RoomEventDto[];
};

export const Rooms = ({ speakingSessionRooms, roomsEvents }: Props) => {
  const { onClickLeft, onClickRight, ref } = useRooms({ speakingSessionRooms });

  const rooms = useMemo(
    () =>
      speakingSessionRooms.map((x) => (
        <Room room={x} roomsEvents={roomsEvents} key={`room-${x.id}`} />
      )),
    [speakingSessionRooms, roomsEvents]
  );

  return (
    <S.Grid>
      <S.Subgrid>
        <S.HeaderLeft>
          <S.Title>Rooms</S.Title>
          <S.TimelineButton onClick={onClickLeft}>
            <Icon name="chevron left" />
          </S.TimelineButton>
        </S.HeaderLeft>

        <S.HeaderCenter ref={ref} id="main-speaking-slots-slider">
          <Timeline />
        </S.HeaderCenter>
        <S.HeaderRight>
          <S.TimelineButton onClick={onClickRight}>
            <Icon name="chevron right" />
          </S.TimelineButton>
        </S.HeaderRight>
      </S.Subgrid>

      {rooms}
    </S.Grid>
  );
};

const S = {
  Grid: styled.div`
    display: grid;
    grid-template-columns: auto 1fr 40px;
    row-gap: 7px;
    user-select: none;
  `,
  Subgrid: styled.div`
    display: grid;
    grid-template-columns: subgrid;
    grid-template-rows: 40px;
    grid-column: 1 / -1;
    position: sticky;
    top: 59px;
    background-color: #fff;
    z-index: 9999;
  `,
  Title: styled.div`
    font-weight: bold;
  `,
  HeaderLeft: styled.div`
    display: grid;
    align-items: center;
    grid-template-columns: auto 40px;
  `,
  HeaderCenter: styled.div`
    overflow-x: auto;
    scrollbar-width: none;
    box-shadow:
      inset -10px 0 10px -10px #d5d5d5,
      inset 10px 0 10px -10px #d5d5d5;
    user-select: none;
    cursor: grab;
    &.${ScrollClasses.scrollDrag} {
      cursor: grabbing;
    }
  `,
  HeaderRight: styled.div`
    display: grid;
    align-items: center;
  `,
  TimelineButton: styled.div`
    display: flex;
    justify-content: center;
    cursor: pointer;
    &: hover > i.icon {
      color: #112a39;
    }
    &: active > i.icon {
      color: #607582;
    }
    & > i.icon {
      margin: 0;
      color: #415561;
      font-size: 18px;
    }
  `,
};
